import { render, staticRenderFns } from "./ForoCategoria.vue?vue&type=template&id=16a8a086"
import script from "./ForoCategoria.vue?vue&type=script&lang=js"
export * from "./ForoCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports